import React from 'react';
import Card from '../../atoms/Card';
import Label from '../../atoms/Label';
import classNames from 'classnames';

export interface ReservationAdvanceList {
  label: string;
  count: number;
}

export interface ReservationAdvanceCardProps {
  title: string;
  itemList: ReservationAdvanceList[];
}

const ReservationAdvanceCard: React.FC<ReservationAdvanceCardProps> = ({ title, itemList }) => {
  return (
    <Card className='u-ws u-mr16 u-mb16'>
      <Card.Header className='u-pt8'>
        <Label className='u-text-m' label={title} data-testid='reservation-advance-card--title' />
      </Card.Header>
      <Card.Content>
        {itemList.map((item, index) => (
          <div className={classNames('u-flex', itemList.length - 1 !== index && 'u-mb4')} key={index}>
            <Label
              className={classNames('u-flex-1', (item.label === '未実施' || item.label === '再架電') && 'u-text-danger')}
              label={item.label}
              data-testid={`reservation-advance-card--label-${index}`}
            />
            <Label
              className={classNames(
                'u-text-bold u-text-2l',
                item.label === '未実施' || item.label === '再架電' ? 'u-text-danger' : 'u-text-black'
              )}
              label={item.count.toString()}
              data-testid={`reservation-advance-card--count-${index}`}
            />
          </div>
        ))}
      </Card.Content>
    </Card>
  );
};
export default ReservationAdvanceCard;
